import React from 'react';
import { createRoot } from 'react-dom/client';
import { AlpineComponent } from 'alpinejs';

import { getTypesenseSearchClient } from '../../../javascripts/typesense';
import { default as EventListRoot } from './components/EventList';
import EventListProvider from './context/EventListProvider';
import { TypesenseSearchConfig } from '../../../javascripts/typesense';

export type FacetBase = { attribute: string; label: string };

export type FacetCheckboxGroup = {
  type: 'checkbox-group';
} & FacetBase;

export type FacetDateRange = {
  type: 'date-range';
  inputLabels: { min: string; max: string };
} & FacetBase;

export type EventListData = {
  showLoadMore?: boolean;
  cta?: {
    label: string;
    href: string;
  };
  headline?: string;
  i18n: {
    openFilter: string;
    closeFilter: string;
    changeFilter: string;
    dateRange: string;
    pagination: string;
    showMore: string;
    showLess: string;
    loadMore: string;
    noFilterOptions: string;
    clearFilter: string;
    applyFilter: string;
  };
  facets?: (FacetCheckboxGroup | FacetDateRange)[];
  search: {
    indexName?: string;
    queryBy: string | string[];
    filterBy: string | string[];
    filters?: string;
    limit?: number;
    config: TypesenseSearchConfig;
  };
};

const EventList = ({
  facets = [],
  headline,
  i18n,
  showLoadMore,
  cta,
  search
}: EventListData): AlpineComponent => ({
  init() {
    const searchClient = getTypesenseSearchClient(
      {
        query_by: search.queryBy,
        // @ts-ignore
        filter_by: search.filterBy,
        limit: search.limit,
        sort_by: 'start_date_timestamp:asc'
      },
      search.config
    );

    const root = createRoot(this.$root);

    root.render(
      <EventListProvider
        i18n={i18n}
        search={search}
        facets={facets}
        headline={headline}
        cta={cta}
        showLoadMore={showLoadMore}
      >
        <EventListRoot
          searchClient={searchClient}
          indexName={search.indexName}
        />
      </EventListProvider>
    );
  }
});

export default EventList;
